module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-4.e9eff0fb.png";